export { default as ApiErrorCodes } from './ApiErrorCodes';
export { default as ContractSignatureFileType } from './ContractSignatureFileType';
export { default as Errors } from './Errors';
export { default as Genders } from './Genders';
export { default as LoanTypes } from './LoanTypes';
export { default as MaritalStatus } from './MaritalStatus';
export { default as UFs } from './UFs';

export const QUEUE_CONTRACT_LIMIT = 5;
